<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="关键字"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li style="display: flex; align-items: center">
        <el-button type="primary" icon="Plus" link @click="onOpenCompile()">
          添加
        </el-button>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column label="封面图" width="120" align="center">
          <template #default="{ row }">
            <el-image
              v-if="row.Fm"
              :src="$http.defaults.baseURL + row.Fm"
              style="width: 80px; height: 50px"
              fit="cover"
              :preview-src-list="[$http.defaults.baseURL + row.Fm]"
              preview-teleported
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="Bt"
          sortable="Bt"
          label="标题"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.Params.Key)
          "
          min-width="150"
        />
        <el-table-column
          prop="Fbt"
          sortable="Fbt"
          label="副标题"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.Params.Key)
          "
          min-width="150"
        />
        <el-table-column label="类型" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="row.Lx === 0 ? 'danger' : 'info'" size="small">
              {{ row.Lx === 0 ? '主Banner' : '普通Banner' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="Djdz"
          label="跳转地址"
          min-width="200"
          :formatter="
            (row, column, cellValue) =>
              cellValue || '-'
          "
        />
        <el-table-column prop="Xh" sortable="Xh" label="排序" width="80" align="center" />
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="创建信息"
          width="160"
          :formatter="(row) => $tab_GroupFormat(row.CjrXm, row.Cjsj)"
        />
        <el-table-column
          prop="IsQy"
          label="启用"
          align="center"
          fixed="right"
          width="80"
        >
          <template #default="{ row }">
            <el-switch
              v-model="row.IsQy"
              style="
                --el-switch-on-color: #13ce66;
                --el-switch-off-color: #ff4949;
              "
              size="small"
              @change="onChangeQy(row.Id, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="170"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Edit"
              link
              @click="onOpenCompile(row.Id)"
              >编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCompile"
        :title="state.compileTitle + '首页轮播'"
        @close="onCloseCompile(false)"
      >
        <c_compile
          @close="
            state.showCompile = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_compile>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { homelunbo_list, homelunbo_delete, homelunbo_change } from "@/http/api";
import { ElMessageBox, ElMessage } from "element-plus";

import c_compile from "./Compile.vue";
export default {
  components: {
    c_compile,
  },
  setup() {
    const state = reactive({
      params: {
        PageSize: 20,
        PageIndex: 1,
        Params: {},
        Order: "Xh",
        Asc: true,
      },
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      homelunbo_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onOpenCompile = (id) => {
      state.compileTitle = id ? "修改" : "添加";
      state.selectId = id;
      state.showCompile = true;
    };

    const onCloseCompile = (refresh) => {
      state.showCompile = false;
      if (refresh) {
        onLoad();
      }
    };

    const onSortChange = (column) => {
      state.params.Order = column.prop;
      state.params.Asc = column.order === "ascending";
      onLoad();
    };

    const onReset = () => {
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Params: {},
          Order: "Xh",
          Asc: true,
        },
      });
      onLoad();
    };

    const onDelete = (id) => {
      ElMessageBox.confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        homelunbo_delete(id).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert("删除成功", "提示", {
              type: "success",
              callback: () => {
                onLoad();
              },
            });
          } else {
            ElMessage({
              message: res.data,
              type: "error",
            });
          }
        });
      });
    };

    const onChangeQy = (id, e) => {
      homelunbo_change(id, e).then((res) => {
        if (res.status == 200)
          ElMessage({
            type: "success",
            message: res.data,
            grouping: true,
          });
      });
    };

    return {
      state,
      onLoad,
      onOpenCompile,
      onCloseCompile,
      onSortChange,
      onReset,
      onDelete,
      onChangeQy,
    };
  },
};
</script>

<style scoped lang="less">
</style>
